var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgThredots(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6C0 2.68629 2.68629 0 6 0H18C21.3137 0 24 2.68629 24 6V18C24 21.3137 21.3137 24 18 24H6C2.68629 24 0 21.3137 0 18V6Z",
    fill: "#808080",
    fillOpacity: 0.06
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 10.3804C11.2014 10.3804 10.5469 11.0349 10.5469 11.8336C10.5469 12.6324 11.2014 13.2869 12.0001 13.2869C12.7989 13.2869 13.4534 12.6324 13.4534 11.8336C13.4534 11.0349 12.7989 10.3804 12.0001 10.3804Z",
    fill: "#242424"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.45325 10.3804C5.65452 10.3804 5 11.0349 5 11.8336C5 12.6324 5.65452 13.2869 6.45325 13.2869C7.25198 13.2869 7.9065 12.6324 7.9065 11.8336C7.9065 11.0349 7.25198 10.3804 6.45325 10.3804Z",
    fill: "#242424"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M17.547 10.3804C16.7483 10.3804 16.0938 11.0349 16.0938 11.8336C16.0938 12.6324 16.7483 13.2869 17.547 13.2869C18.3457 13.2869 19.0002 12.6324 19.0002 11.8336C19.0002 11.0349 18.3457 10.3804 17.547 10.3804Z",
    fill: "#242424"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThredots);
export default __webpack_public_path__ + "static/media/THREDOTS.dc81be2ab42304d3d9f71383803681a1.svg";
export { ForwardRef as ReactComponent };